// {{WORKTREE_ROOT}}/picosponsorconsole/app/utils/loadState.ts
// PLAN2 WP10 — client-safe. A screen renders "empty" only from { ok: true } with no rows; { ok: false } renders
// LoadFailed with a Retry and (off-prod) the request id (C-100).
export interface SerializedApiError { code: string; messageId: string; status: number; requestId: string | null; awsRequestId: string | null }
export type LoadResult<T> = { ok: true; data: T } | { ok: false; error: SerializedApiError };

export function describeThrown(error: unknown): SerializedApiError {
  if (error && typeof error === "object" && "status" in error && "data" in error) {
    const status = Number((error as { status: number }).status);
    const data = (error as { data: unknown }).data as Partial<SerializedApiError> | null;
    if (data && typeof data === "object" && typeof data.code === "string" && data.code) {
      return { code: data.code, messageId: typeof data.messageId === "string" ? data.messageId : "errors.internal", status, requestId: data.requestId ?? null, awsRequestId: data.awsRequestId ?? null };
    }
    return { code: status === 404 ? "NOT_FOUND" : status === 401 ? "UNAUTHORIZED" : `HTTP_${status}`, messageId: status === 404 ? "errors.not-found" : status === 401 ? "errors.unauthorized" : "errors.internal", status, requestId: null, awsRequestId: null };
  }
  return { code: "INTERNAL", messageId: "errors.internal", status: 500, requestId: null, awsRequestId: null };
}
